import React, { useEffect, useState } from "react"
import Header from "../components/Header"
import HeroSection from "../sections/home/HeroSection"
import HottestCategorySection from "../sections/home/HottestCategorySection"
import ProductQuestionSection from "../sections/home/ProductQuestionSection"
import NewlyListedSection from "../sections/home/NewlyListedSection"
import KeyFeaturesSection from "../sections/home/KeyFeaturesSection"
import MostPopularSection from "../sections/home/MostPopularSection"
import Footer from "../components/Footer"
import { getAllCategories } from "../firebase/categories"
import { getAllListings } from "../firebase/listings"
import { getShopifyProducts } from "../firebase/shopify"
import { filterBlockedItems, getBlockedSellerIds } from "../firebase/blocks"
import CardItem from "../components/cards/CardItem"
import { useAtom } from "jotai"
import { userAtom } from "../store"
import Slider from "react-slick"
import Button from "../components/commons/Button"
import { Link, useNavigate } from "react-router-dom"
import PlanDialog from "../components/dialogs/PlanDialog"
import SidebarIndividualChat from "../components/sidebars/SidebarIndividualChat"
// import { Helmet } from "react-helmet"
import { Helmet } from "react-helmet-async";
import LoadingScreen from "../components/Loading"
import SidebarCart from "../components/sidebars/SidebarCart"
import { useAuth } from "../context/authContext"

const Home = () => {
  const [categories, setCatgories] = useState(null)
  const [cards, setCards] = useState(null)
  const [shopifyProducts, setShopifyProducts] = useState([])
  const [userData, setUserData] = useAtom(userAtom)
  const [loading1, setLoaindg1] = useState(true)
  const [loading2, setLoaindg2] = useState(true)
  const { membershipsForUser } = useAuth()
  const navigate = useNavigate()
  const [showPlanDialog, setShowPlanDialog] = useState(false)
  const [activeDialogPlan, setActiveDialogPlan] = useState(null)

  const planLabels = {
    basic: "Basic",
    pro: "Pro",
    elite: "Elite",
  }

  const openPlanDialog = (plan) => {
    setActiveDialogPlan(plan)
    setShowPlanDialog(true)
  }

  const closePlanDialog = () => {
    setShowPlanDialog(false)
    setActiveDialogPlan(null)
  }

  const desktopSliderSettings = {
    dots: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    navigator: false,
    customPaging: function (i) {
      return (
        <div className="slick-dot lg:hidden w-[8px] lg:w-[10px] h-[8px] lg:h-[10px] cursor-pointer bg-white/30 backdrop-blur-sm"></div>
      );
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          initialSlide: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          initialSlide: 1,
        }
      }
    ]
  }

  const mobileSliderSettings = {
    dots: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 1,
    navigator: false,
    customPaging: function (i) {
      return (
        <div className="slick-dot lg:hidden w-[8px] lg:w-[10px] h-[8px] lg:h-[10px] cursor-pointer bg-white/30 backdrop-blur-sm"></div>
      );
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          initialSlide: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          initialSlide: 1,
        }
      }
    ]
  }

  useEffect(() => {
    // authContext hydrates `userData` from localStorage after this page's
    // first render, so fetching on mount would filter against an empty
    // block list and show a buyer one frame of the sellers they blocked.
    // localStorage is the only synchronous signal that a buyer is coming,
    // and it is set in the same effect flush, so nothing is really delayed.
    if (localStorage.getItem('userData') && !userData?.id) return

    const userId = userData && userData.id ? userData.id : null

    getAllCategories().then(items => {
      setCatgories(items)
      setLoaindg1(false)
    })

    // Both feeds are filtered against the same block list, so a blocked
    // seller disappears from the local listings and from their Shopify
    // stores at once. Resolved first because it decides what either feed
    // may show, and this effect already re-runs when `userData` lands.
    getBlockedSellerIds(userId).then((blockedSellerIds) => {
      getAllListings(userId).then(items => {
        setCards(filterBlockedItems(items, blockedSellerIds))
        setLoaindg2(false)
      })

      getShopifyProducts().then(items => {
        setShopifyProducts(filterBlockedItems(items, blockedSellerIds))
      })
    })
  }, [userData])

  return (
    <div>
      <Helmet prioritizeSeoTags>
        <title>Buy, Sell & Trade Pokémon & Collectible Cards | Card Shop Exchange</title>
        <meta name="description" content="Join Card Shop Exchange, the ultimate marketplace for trading Pokémon, Yu-Gi-Oh, One Piece, and more. Secure payments, verified sellers, and hassle-free transactions." />
      </Helmet>

      <Header />
      <SidebarIndividualChat />
      <SidebarCart />

      {
        loading1 && loading2 ?
          <LoadingScreen />
          :
          <>
            <HeroSection />

            {shopifyProducts.length > 0 && (
              <div className="container mx-auto px-10 mt-[80px] text-white">
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <h2 className="text-primary text-[30px] uppercase font-aero">Shopify Products</h2>
                    <p className="text-[#a3a3a3] text-sm mt-2">Shop-managed marketplace inventory</p>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                  {shopifyProducts.slice(0, 6).map((product) => (
                    <CardItem key={product.id} card={product} />
                  ))}
                </div>
              </div>
            )}

            <div className="pt-20 max-lg:pb-20 lg:pt-40 ">
              <HottestCategorySection categories={categories} />

              {
                !userData &&
                <div className="container mx-auto px-10 mt-[140px] text-white max-lg:mb-14">
                  <Slider {...desktopSliderSettings} className="w-full membership-slider  dots-down !hidden lg:!block">
                    <div>
                      <div className="!flex w-full min-h-[450px]">
                        <div className={`px-7 py-9 w-full lg:min-h-[350px] min-h-[370px] lg:mt-auto max-lg:mb-auto bg-[#0d0d0d] text-white border-style-decoration`}>
                          <div className="w-fit px-3 py-1 text-[10px] rounded-[12px] text-white bg-primary border-white border-[1px]">
                            Basic Plan
                          </div>

                          <div className="flex items-end mt-6">
                            <h2 className="uppercase font-bold text-3xl">
                              ${membershipsForUser['basic'].price}
                            </h2>
                            {/* <span className="text-2xl font-medium text-white ml-2 mr-3">
                              + ${membershipsForUser['basic'].fee}
                            </span> */}
                            <span className="text-base"> /month</span>
                          </div>

                          <div className="flex gap-y-4 flex-col mt-10">
                            {
                              membershipsForUser['basic'].benefits.map((item, index) =>
                                <div className="w-full flex" key={`${item}-${index}`}>
                                  <img
                                    alt="circle"
                                    src="/assets/icons/icon-check-circle.svg"
                                    className="w-full mr-2 max-w-[18px]"
                                  />
                                  <span className="text-sm">
                                    {item}
                                  </span>
                                </div>
                              )
                            }
                          </div>
                          <div className="mt-8">
                            <Button
                              isActive
                              divClassName="w-full"
                              buttonClassName="!bg-transparent border border-white/20 hover:!bg-white hover:text-black sm:!p-3 !p-3 text-xs"
                              onClick={() => openPlanDialog('basic')}
                            >
                              Pay Annually ${membershipsForUser['basicYearly']?.price}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="relative">
                      <div className="absolute !h-fit top-[20px] lg:right-[-30px] right-0 z-[100] font-bold text-base bg-white border-[1px] border-primary px-5 py-2 text-black rotate-[8deg] z-index-10">
                        Most Popular
                      </div>

                      <div className={`px-7 py-9  lg:min-h-[450px] min-h-[370px] bg-[#0d0d0d] border-style-decoration`}>
                        <div className="w-fit px-3 py-1 lg:text-xs text-[10px] rounded-[12px] text-white bg-primary border-white border-[1px]">
                          Pro Plan
                        </div>

                        <div className="flex items-end mt-6 lg:mt-8">
                          <h2 className="uppercase font-bold lg:text-[45px] text-3xl">
                            ${membershipsForUser['pro'].price}
                          </h2>
                          {/* <span className="text-2xl font-medium text-white ml-2 mr-3">
                            + ${membershipsForUser['pro'].fee}
                          </span> */}
                          <span className="text-base"> /month</span>
                        </div>

                        <div className="flex gap-y-4 flex-col mt-10">
                          {
                            membershipsForUser['pro'].benefits.map((item, index) =>
                              <div className="w-full flex" key={`${item}-${index}`}>
                                <img
                                  alt="circle"
                                  src="/assets/icons/icon-check-circle.svg"
                                  className="w-full mr-2 max-w-[18px]"
                                />
                                <span className="lg:text-base text-sm">
                                  {item}
                                </span>
                              </div>
                            )
                          }
                        </div>
                        <div className="mt-8">
                          <Button
                            isActive
                            divClassName="w-full"
                            buttonClassName="!bg-transparent border border-white/20 hover:!bg-white hover:text-black sm:!p-3 !p-3 text-xs"
                            onClick={() => openPlanDialog('pro')}
                          >
                            Pay Annually ${membershipsForUser['proYearly']?.price}
                          </Button>
                        </div>
                      </div>

                      <Link to='/register'>
                        <Button
                          isActive
                          divClassName="border-style-decoration-container mt-4"
                          buttonClassName="border-style-decoration"
                        >Create Account</Button>
                      </Link>
                    </div>

                    <div>
                      <div className="!flex w-full min-h-[450px]">
                        <div className={`px-7 py-9 w-full lg:mt-auto max-lg:mb-auto lg:min-h-[350px] min-h-[370px] bg-[#0d0d0d] text-white border-style-decoration`}>
                          <div className="w-fit px-3 py-1 text-[10px] rounded-[12px] text-white bg-primary border-white border-[1px]">
                            Elite Plan
                          </div>

                          <div className="flex items-end mt-6">
                            <h2 className="uppercase font-bold text-3xl">
                              ${membershipsForUser['elite'].price}
                            </h2>
                            {/* <span className="text-2xl font-medium text-white ml-2 mr-3">
                              + ${membershipsForUser['elite'].fee}
                            </span> */}
                            <span className="text-base"> /month</span>
                          </div>

                          <div className="flex gap-y-4 flex-col mt-10">
                            {
                              membershipsForUser['elite'].benefits.map((item, index) =>
                                <div className="w-full flex" key={`${item}-${index}`}>
                                  <img
                                    alt="circle"
                                    src="/assets/icons/icon-check-circle.svg"
                                    className="w-full mr-2 max-w-[18px]"
                                  />
                                  <span className="text-sm">
                                    {item}
                                  </span>
                                </div>
                              )
                            }
                          </div>
                          <div className="mt-8">
                            <Button
                              isActive
                              divClassName="w-full"
                              buttonClassName="!bg-transparent border border-white/20 hover:!bg-white hover:text-black sm:!p-3 !p-3 text-xs"
                              onClick={() => openPlanDialog('elite')}
                            >
                              Pay Annually ${membershipsForUser['eliteYearly']?.price}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Slider>

                  <Slider {...mobileSliderSettings} className="w-full membership-slider  dots-down-mobile lg:!hidden">
                    <div>
                      <div className="!flex w-full">
                        <div className={`px-7 py-9 w-full lg:min-h-[350px] min-h-[370px] lg:mt-auto max-lg:mb-auto bg-[#0d0d0d] text-white border-style-decoration`}>
                          <div className="w-fit px-3 py-1 text-[10px] rounded-[12px] text-white bg-primary border-white border-[1px]">
                            Basic Plan
                          </div>

                          <div className="flex items-end mt-6">
                            <h2 className="uppercase font-bold text-3xl mr-3">$50</h2>
                            <span className="text-base">/mo</span>
                          </div>

                          <div className="flex gap-y-4 flex-col mt-10">
                            {
                              membershipsForUser['basic'].benefits.map((item, index) =>
                                <div className="w-full flex" key={`${item}-${index}`}>
                                  <img
                                    alt="circle"
                                    src="/assets/icons/icon-check-circle.svg"
                                    className="w-full mr-2 max-w-[18px]"
                                  />
                                  <span className="text-sm">
                                    {item}
                                  </span>
                                </div>
                              )
                            }
                          </div>
                          <div className="mt-8">
                            <Button
                              isActive
                              divClassName="w-full"
                              buttonClassName="!bg-transparent border border-white/20 hover:!bg-white hover:text-black sm:!p-3 !p-3 text-xs"
                              onClick={() => openPlanDialog('basic')}
                            >
                              Pay Annually ${membershipsForUser['basicYearly']?.price}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="relative overflow-show" style={{ overflow: 'visible' }}>
                      <div className="absolute !h-fit top-[20px] lg:right-[-30px] right-0 z-[100] font-bold text-base bg-white border-[1px] border-primary px-5 py-2 text-black rotate-[8deg]">
                        Most Popular
                      </div>

                      <div className={`px-7 py-9  lg:min-h-[450px] min-h-[370px] bg-[#0d0d0d] border-style-decoration`}>
                        <div className="w-fit px-3 py-1 lg:text-xs text-[10px] rounded-[12px] text-white bg-primary border-white border-[1px]">
                          Pro Plan
                        </div>

                        <div className="flex items-end mt-6 lg:mt-8">
                          <h2 className="uppercase font-bold lg:text-[45px] text-3xl mr-3">$100</h2>
                          <span className="lg:text-xl text-base lg:-translate-y-3 block">/mo</span>
                        </div>

                        <div className="flex gap-y-4 flex-col mt-10">
                          {
                            membershipsForUser['pro'].benefits.map((item, index) =>
                              <div className="w-full flex" key={`${item}-${index}`}>
                                <img
                                  alt="circle"
                                  src="/assets/icons/icon-check-circle.svg"
                                  className="w-full mr-2 max-w-[18px]"
                                />
                                <span className="lg:text-base text-sm">
                                  {item}
                                </span>
                              </div>
                            )
                          }
                        </div>
                        <div className="mt-8">
                          <Button
                            isActive
                            divClassName="w-full"
                            buttonClassName="!bg-transparent border border-white/20 hover:!bg-white hover:text-black sm:!p-3 !p-3 text-xs"
                            onClick={() => openPlanDialog('pro')}
                          >
                            Pay Annually ${membershipsForUser['proYearly']?.price}
                          </Button>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="!flex w-full">
                        <div className={`px-7 py-9 w-full lg:mt-auto max-lg:mb-auto lg:min-h-[350px] min-h-[370px] bg-[#0d0d0d] text-white border-style-decoration`}>
                          <div className="w-fit px-3 py-1 text-[10px] rounded-[12px] text-white bg-primary border-white border-[1px]">
                            Elite Plan
                          </div>

                          <div className="flex items-end mt-6">
                            <h2 className="uppercase font-bold text-3xl mr-3">$250</h2>
                            <span className="text-base">/mo</span>
                          </div>

                          <div className="flex gap-y-4 flex-col mt-10">
                            {
                              membershipsForUser['elite'].benefits.map((item, index) =>
                                <div className="w-full flex" key={`${item}-${index}`}>
                                  <img
                                    alt="circle"
                                    src="/assets/icons/icon-check-circle.svg"
                                    className="w-full mr-2 max-w-[18px]"
                                  />
                                  <span className="text-sm">
                                    {item}
                                  </span>
                                </div>
                              )
                            }
                          </div>
                          <div className="mt-8">
                            <Button
                              isActive
                              divClassName="w-full"
                              buttonClassName="!bg-transparent border border-white/20 hover:!bg-white hover:text-black sm:!p-3 !p-3 text-xs"
                              onClick={() => openPlanDialog('elite')}
                            >
                              Pay Annually ${membershipsForUser['eliteYearly']?.price}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Slider>

                  <Link to='/register' className="lg:!hidden">
                    <Button
                      isActive
                      divClassName="border-style-decoration-container mt-4"
                      buttonClassName="border-style-decoration"
                    >Create Account</Button>
                  </Link>

                </div>
              }
              {/* <MembershipSection /> */}
              <ProductQuestionSection />
              <NewlyListedSection categories={categories} cards={cards} />
              <KeyFeaturesSection />
              {/* <MostPopularSection cards={cards} /> */}
            </div>
          </>
      }

      <PlanDialog
        open={showPlanDialog}
        onClose={closePlanDialog}
        activePlan={activeDialogPlan}
        membershipsForUser={membershipsForUser}
        onConfirm={(membershipKey) => {
          navigate(`/plans?plan=${membershipKey}`)
          closePlanDialog()
        }}
      />
      <Footer />
    </div >
  )
}

export default Home
